import { Lightbulb } from "lucide-react";

export const FloatingBulb = ({
  size = 48,
  className = "",
  style = {},
  color = "#FACC15",
  ariaLabel = "Accento Idea 360",
  testId = "floating-bulb",
}) => {
  return (
    <div
      className={`float-bulb pointer-events-none ${className}`}
      style={style}
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <Lightbulb
        size={size}
        strokeWidth={1.5}
        color={color}
        fill="rgba(250, 204, 21, 0.18)"
      />
    </div>
  );
};

export default FloatingBulb;
